export default "__VITE_ASSET__84cd86ca__"